module.exports = __webpack_public_path__ + "static/landing-project-90ddf7897abd22e40845d240954efcd9.png";